// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"StatsTiles-primaryButton-2-OMVu","tiles":"StatsTiles-tiles-1m6Th3"};